export type TeacherWorkScheduleDTO = {
  teacherId?: string | number | null;
  /** Bit mask Mon..Sun => bits 0..6 */
  workingDaysMask: number;
  /** HH:mm */
  startTime: string;
  /** HH:mm */
  endTime: string;
  timezone?: string | null;
};

export const WEEKDAY_LABELS: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
